import { createFileRoute } from '@tanstack/react-router';
import UserCreate from '~/containers/UserCreate';

export const Route = createFileRoute('/users/create')({
  component: UserCreate,
});
